import debug from 'bows';
const log = debug('tabs-cards');

class SimpleTabs {
    constructor(node) {
        console.log(node);

        this.node = node;
        this.active = -1;

        this.navs = Array.from(this.node.querySelectorAll('.agenda-tabs__nav--link'));
        this.tabs = Array.from(this.node.querySelectorAll('.agenda-tabs__content-item'));

        this.navs.forEach((nav, index) => {
            nav.addEventListener('click', (e) => {
                e.preventDefault();
                this.activate(index);
            });
        });

        this.activate(0);
        log(this);
    }

    activate(index) {
        if (this.active > -1) {
            this.navs[this.active].classList.remove('is-active');
            this.tabs[this.active].classList.remove('is-open');
        }

        this.active = index;

        this.navs[this.active].classList.add('is-active');
        this.tabs[this.active].classList.add('is-open');
    }
}

export default SimpleTabs;

